import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useNotification } from "~hooks/useNotification";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";
import { useApi } from "../../../shared/api";
import type { IUniformModel } from "../models/IUniformModel";

export const useDeleteUniform = () => {
  const { sport, organizationId } = useParams();
  const { mutateData } = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation({
    mutationFn: (uniform: IUniformModel) => {
      return mutateData({
        url: `${sport}/o/${organizationId}/uniforms/${uniform.uniformId}?forceDelete=true`,
        method: "DELETE",
      });
    },
    onSuccess: async (response: any, uniform: IUniformModel) => {
      if (isDefaultOperationSucceeded(response)) {
        await queryClient.invalidateQueries({
          queryKey: ["uniformItems", sport, organizationId, uniform.uniformId],
        });

        await queryClient.invalidateQueries({
          queryKey: ["uniforms", sport, organizationId, uniform.baseType, uniform.baseId],
        });

        notification.success({
          message: formatMessage({ id: "uniform.delete.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
